import PropTypes from 'prop-types'
import React from 'react'
import {
  ContentIcon as ContentIconComponent
} from 'components/Content'
import classes from './ContentIcon.module.scss'

export class ContentIcon extends React.Component {
  static propTypes = {
    className: PropTypes.string
  }

  render () {
    let {
      children,

      className,

      ...restProps
    } = this.props

    let compClassName = classes.contentIcon
    if (className) compClassName += ' ' + className

    return (
      <ContentIconComponent
        {...restProps}
        className={compClassName}
      >
        {children}
      </ContentIconComponent>
    )
  }
}

export default ContentIcon
